import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
export default class ImagesGallery {
    constructor() {
        this.section = document.querySelector('.components-block-images-gallery');
        this.slider = this.section.querySelector('.swiper--components-block-images-gallery');
        this.navigationPrev = document.querySelector('.slider-button-prev--components-block-images-gallery');
        this.navigationNext = document.querySelector('.slider-button-next--components-block-images-gallery');
        this.pagination = this.section.querySelector('.swiper-pagination-nav--components-block-images-gallery');
        this.modalSwipers = document.querySelectorAll('.swiper-modal-galeria');

        this.btnSeePhotos = this.section.querySelector('.btnSeePhotos');

        this.ready();
    }

    ready() {
        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination],
            grabCursor: true,
            slidesPerView: 3,
            spaceBetween: 0,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    pagination: {
                        el: this.pagination,
                        type: 'fraction',
                    },
                },
                1024: {
                    slidesPerView: 5,
                    pagination: '',
                },
            },
        });

        const slidesClick = this.slider.querySelectorAll('.swiper--components-block-images-gallery .swiper-slide');
        slidesClick.forEach((slide) => {
            slide.addEventListener('click', () => {
                this.openModalPhoto();
            });
        });

        this.btnSeePhotos.addEventListener('click', () => {
            this.openModalPhoto();
        });

        this.modalSwipers.forEach((modalSwiper) => {
            const swiper = new Swiper(modalSwiper, {
                modules: [Navigation],
                grabCursor: true,
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: true,
                navigation: {
                    nextEl: modalSwiper.querySelector('.slider-button-next'),
                    prevEl: modalSwiper.querySelector('.slider-button-prev'),
                },
            });
        });
    }

    openModalPhoto() {
        this.section.querySelector('.modal-galeria').classList.add('active');
        this.section.querySelector('.closeModal').addEventListener('click', () => {
            this.section.querySelector('.modal-galeria').classList.remove('active');
        });
    }
}

if (document.querySelector('.components-block-images-gallery')) {
    new ImagesGallery();
}
